import React from 'react';
import PartyMaster from './PartyMaster';

function TransportParties() {
  return (
    <PartyMaster
      title="Transport parties"
      modalTitle="Add transport party"
      addButtonText="Add transport party"
      searchPlaceholder="Search transport parties…"
      partyCategory="TRANSPORT_PARTIES"
      namePlaceholder="Transport / transporter name"
    />
  );
}

export default TransportParties;
